<template>
  <div class="page-table scrollable" id="affix-container">
    <b-container style="margin-top:30px">
      <b-modal
        title="Yetki grubu oluştur"
        width="30%"
        hide-footer
        v-model="addRoleModal"
      >
        <b-form style="width:auto !important" v-loading="isLoadingForm" @submit.native.prevent="addRole">
          <b-form-group label="Yetki grubu adı">
            <b-form-input
              minlength="2"
              maxlength="255"
              required
              v-model="role.name"
            ></b-form-input>
          </b-form-group>
          <b-form-group style="margin-top:15px">
            <b-button native-type="submit" icon="el-icon-check" variant="success">Yetki grubunu oluştur</b-button>
          </b-form-group>
        </b-form>
      </b-modal>

      <b-modal
        title="Yetki grubu düzenle"
        width="30%"
        hide-footer
        v-model="editRoleModal"
      >
        <b-form style="width:auto !important" v-loading="isLoadingForm" @submit.native.prevent="editRole">
          <b-form-item label="Yetki grubu adı">
            <b-form-input
              minlength="2"
              maxlength="255"
              required
              v-model="editRoleForm.name"
            ></b-form-input>
          </b-form-item>
          <b-form-item style="margin-top:15px">
            <b-button native-type="submit" icon="el-icon-check" variant="success">Yetki grubunu güncelle</b-button>
          </b-form-item>
        </b-form>
      </b-modal>

      <b-card v-loading="isLoading">
        <b-button
          :disabled="!$permission('permission_process')"
          variant="primary"
          class="add-button mb-30"
          icon="mdi mdi-playlist-plus"
          @click="addRoleModal = true"
        >Yetki Grubu Oluştur</b-button>
        <br><br>
        <b-tabs content-class="mt-3">
          <b-tab v-for="role in roles" :key="role.id" :title="role.name">
            <span slot="label">
              {{role.name}}
              <div class="actions">
                <el-button :disabled="!$permission('permission_process')" @click="editRoleForm.id = role.id; editRoleForm.name = role.name; editRoleModal = true" type="text" size="mini">
                  <i class="mdi mdi-pencil text-success"></i>
                </el-button>
                <el-button :disabled="!$permission('permission_process')" @click=deleteRole(role) type="text" size="mini">
                  <i class="mdi mdi-delete text-danger"></i>
                </el-button>
              </div>
            </span>
            <div>
              <b-form style="width:100% !important; margin:0px !important">
                <b-row>
                <b-tabs tab-position="left">
                  <b-tab v-for="(x, index) in permissions" :key="index" :title="index">
                    <h1 style="font-size: 20px; color: var(--main-color); margin: 5px 0 15px 0;">{{ index }} Yetkileri</h1>
                    <b-checkbox-group v-model="role.perm_ids">
                      <b-col v-for="permission in x" :key="permission.id" class="mt-20 mr-20">
                        <el-checkbox :disabled="!$permission('permission_process')" :label="permission.id" v-model="role.perm_ids"> {{permission.description}} </el-checkbox>
                      </b-col>
                    </b-checkbox-group>
                  </b-tab>
                </b-tabs>
                </b-row>
                <b-row style="margin:20px 0">
                  <b-form-item>
                    <b-button :disabled="!$permission('permission_process')" @click="saveRole(role)" variant="primary">Yetki Grubunu Kaydet</b-button>
                  </b-form-item>
                </b-row>
              </b-form>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'permissions',
  data() {
    return {
      isLoadingForm: false,
      isLoading: true,
      addRoleModal: false,
      editRoleModal: false,
      roles: [],
      permissions: {},
      role:{
        name: null
      },
      editRoleForm:{
        id: null,
        name: null
      },
    };
  },
  mounted(){
    this.fetchData()
  },
  methods: {
    fetchData(){
      this.isLoading = true
      axios
        .get("/permissions")
        .then(response => {
          this.roles = response.data.data;
          this.permissions = response.data.permissions
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    deleteRole(role){
      this.$confirm(role.name + " adlı yetki grubunu silmek istediğinize emin misiniz ?")
        .then(dialog => {
          this.isLoadingForm = true;
          axios
            .delete('/permissions/' + role.id)
            .then(response => {
              if (response.data.status) {
                this.$notify({
                  title: "Yetki grubu silindi",
                  message: "Başarılı",
                  type: "success"
                });
                this.fetchData()
              }
            })
            .catch(() => {})
            .finally(() => {
              this.isLoadingForm = false;
            });
        })
        .catch(error => {
          this.isLoadingForm = false;
        });
    },
    editRole(){
      this.$confirm("Yetki grubunu oluşturmak istediğinize emin misiniz ?")
        .then(dialog => {
          this.isLoadingForm = true;
          axios
            .patch('/permissions/' + this.editRoleForm.id + '/name', {name: this.editRoleForm.name})
            .then(response => {
              if (response.data.status) {
                this.$notify({
                  title: "Yetki grubu güncellendi",
                  message: "Başarılı",
                  type: "success"
                });
                this.editRoleModal = false
                this.fetchData()
              }
            })
            .catch(() => {})
            .finally(() => {
              this.isLoadingForm = false;
            });
        })
        .catch(error => {
          this.isLoadingForm = false;
        });
    },
    addRole(){
      this.$confirm("Yetki grubunu oluşturmak istediğinize emin misiniz ?")
        .then(dialog => {
          this.isLoadingForm = true;
          axios
            .post('/permissions', this.role)
            .then(response => {
              if (response.data.status) {
                this.$notify({
                  title: "Yetki grubu oluşturuldu",
                  message: "Başarılı",
                  type: "success"
                });
                this.addRoleModal = false
                this.fetchData()
              }
            })
            .catch(() => {})
            .finally(() => {
              this.isLoadingForm = false;
            });
        })
        .catch(error => {
          this.isLoadingForm = false;
        });
    },
    saveRole(role){
      this.$confirm(role.name + " Adlı yetki grubunu güncellemek istediğinize emin misiniz ?")
        .then(dialog => {
          this.isLoading = true;
          axios
            .patch('/permissions/' + role.id, {permissions: role.perm_ids})
            .then(response => {
              if (response.data.status) {
                this.$notify({
                  title: "Yetki grubu güncellendi",
                  message: "Başarılı",
                  type: "success"
                });
              }
            })
            .catch(() => {})
            .finally(() => {
              this.isLoading = false;
            });
        })
        .catch(error => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style lang="scss">

.el-tabs--left .el-tabs__header.is-left {
  width: 250px;
  .el-tabs__item.is-left {
    text-align: left;
    span {
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-weight: 600;
    }
  }
}
</style>